import { useEffect, useRef } from "react";

/**
 * If there are unsaved changes, call saveFn when leaveKey changes or the
 * component unmounts (subject, groups, on-level toggle, navigate away).
 *
 * On-level Homeroom/Groups use a stable leaveKey so this only fires on true
 * unmount (side nav / breadcrumb). Subject/EPR switches stay on awaited
 * commitIfNeeded. Diff may use a changing leaveKey for roster/subject leave.
 */
const useFlushOnLeave = (saveFn, hasChanges, leaveKey) => {
    const saveRef = useRef(saveFn);
    const dirtyRef = useRef(hasChanges);
    saveRef.current = saveFn;
    dirtyRef.current = hasChanges;

    useEffect(
        () => () => {
            if (dirtyRef.current) {
                saveRef.current();
            }
        },
        [leaveKey]
    );
};

export default useFlushOnLeave;
